
import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";
import Form from 'react-bootstrap/Form';
import ReCAPTCHA from "react-google-recaptcha";
import "../../scss/popup.scss";
import { isValidEmail } from '../../utils/utils';
import CustomPopup from './custom-popup';
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const CaptchaSubscribePopup = forwardRef((props, ref) => {
  console.log('props ', props)
  const captchaRef = useRef(null);
  const [show, setShow] = React.useState(false);
  const [showForm, setShowForm] = useState(true);
  const [email, setEmail] = useState('');
  const popupCloseHandler = (e) => {
    setShow(false);
    setEmail('');
    setShowForm(true);
  };
  // The component instance will be extended
  // with whatever you return from the callback passed
  // as the second argument
  useImperativeHandle(ref, () => ({
    close() {
      setShow(false);
      setEmail('');
      setShowForm(true);
    },

    open(email = '') {
      if (email) {
        setEmail(email);
      }
      setShow(true);
    }
  }));

  const submit = async (e) => {
    e.preventDefault();
    // check 
    if (email) {
      // validate email
      if (!isValidEmail(email)) {
        alert('Email is invalid!!!');
        return;
      }
      const token = captchaRef.current.getValue();
      if (!token) {
        alert("Please Confirm You Are Not a Robot!");
      } else {
        //
        const data = {
          recaptchaToken: token,
          email: email,
          name: `${email}`,
          phone: '',
          subject: '[Inventiv] New subcribe from ' + email,
          message: `New subcribe from  ${email}`,
          site: 'inventiv.org'
        }
        // send mail
        fetch("https://api.trustyip.com/subcribers/add", {
          "method": "POST",
          "headers": {
            "content-type": "application/json",
            "accept": "application/json"
          },
          "body": JSON.stringify(data)
        })
          .then(response => response.json())
          .then(response => {
            // reset
            setShowForm(false);
            setEmail('');
            // action
            if (props.page) {
              document.location.href = props.page
            }
          })
          .catch(err => {
            alert('There is something wrong. Please try again later!');
            console.log(err);
          });
        // close popup
        // childRef.current?.close();
      }
    } else {
      alert('Please enter your information!');
    }
  }
  return (
      <CustomPopup
        onClose={popupCloseHandler}
        show={show}
        title="">
        {
          showForm ?
            <div>
              <h3 className="text-center mb-4">Please verify that you are not a robot.</h3>
              <Form >

                <div className="mb-1 text-center" style={{ display: "grid", justifyContent: "center"}}>
                  <ReCAPTCHA
                    sitekey={process.env.RECAPTCHA_SITE_KEY}
                    ref={captchaRef}
                  />
                </div>
                <button className='btn btn-warning w-100' onClick={submit}>Submit</button>
              </Form>
            </div>
            :
            <div class="_form-thank-you">
              <h3 className='text-center'>Thank you!</h3>
              <p className='text-center'>
                Thank you for contacting us. We will follow up with you soon
              </p>
              <p className='text-center'>Inventiv.org.</p>
            </div>
        }
      </CustomPopup>
  )
});

export default CaptchaSubscribePopup;
